<template>
    <div class="form-elements">
        <div class="row" v-show="!download.load">
            <div class="form-group">
                <div class="col-md-6">
                    <input type="date" v-model="dataInicial">
                </div>
                <div class="col-md-6">
                    <input type="date" v-model="dataFinal">
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-12">
                    <button @click="getPraticasPendentes()" class="btn btn-dark btn-micro">Gerar Planilha</button>
                </div>
            </div>
        </div>
        <div v-show="download.load">
            <span>Pode demorar um pouco...</span>
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                    </component>
                </div>
            </div>
        </div>
        <div class="row">
            <fieldset class="col-md-3 mb-3">
                <legend>Autoescola</legend>
                <model-select :options="selectCFC" v-model="filtros.selectedCFC" placeholder="Selecione uma autoescola">
                </model-select>
            </fieldset>

            <fieldset class="col-md-5" id="periodoConsultado">
                <legend>Período a Ser Consultado</legend>
                <div class="form-group">
                    <div class="col-md-6 p-0 pr-2">
                        <input type="date" class="form-control border rounded pl-2 pr-2" v-model="filtros.dataInicio">
                    </div>
                    <div class="col-md-6 p-0 pl-2">
                        <input type="date" class="form-control border rounded pl-2 pr-2" v-model="filtros.dataFim">
                    </div>
                </div>
            </fieldset>
        </div>
        <div class="row">
            <fieldset class="col-md-3 mb-3">
                <legend>
                    <span>Nome do Aluno</span>
                </legend>
                <div class="form-group">
                    <input type="text" class="form-control pt-0 pl-2 border rounded" v-model="filtros.nomeAluno">
                </div>
            </fieldset>

            <fieldset class="col-md-3 mb-3">
                <legend>
                    <span>Nome do Instrutor</span>
                </legend>
                <div class="form-group">
                    <input type="text" ref="instrutor" class="form-control pt-0 pl-2 border rounded" v-model="filtros.instrutor">
                </div>
            </fieldset>
        </div>
        <div class="row">
            <div class="col-3 text-right">
                <button class="btn btn-info col-12 btn-micro mb-5 d-flex justify-content-center" @click="searchBy"
                    :disabled="aulasLoading">
                    <component v-if="aulasLoading" :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'"
                        :size="20"></component>

                    <div v-else>
                        <i id="consultButton" class="fa fa-search pr-3 icon-branco"></i>
                        <span class="font-button-modified">Consultar</span>
                    </div>
                </button>
            </div>
            <div class="col-3 text-right">
                <button class="btn btn-danger col-12 btn-micro mb-5" @click="clearInputs">
                    <i id="clearButton" class="fa fa-file-excel-o pr-3 icon-branco"></i>
                    <span class="font-button-modified">Limpar</span>
                </button>
            </div>
        </div>
        <div class="row d-flex justify-content-center flex-column align-items-center">
            <div class="row">
                <div class="col mx-auto">
                    <pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center">
                    </pagination>
                </div>
            </div>
            <template v-if="!aulasLoading">
                <template v-if="!table.load">
                    <table class="table table-responsive-sm">
                        <thead>
                            <tr>
                                <th>Auto Escola</th>
                                <th>Aluno</th>
                                <th>Instrutor</th>
                                <th>Data da aula</th>
                                <th>Status</th>
                                <th>Tempo após o retorno</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="aulas.length === 0">
                                <td colspan="6" class="text-center">Nenhum registro encontrado.</td>
                            </tr>
                            <tr v-for="(aula, index) in aulas" :key="index" v-else>
                                <td>{{ aula.autoescola }}</td>
                                <td>{{ aula.aluno }}</td>
                                <td>{{ aula.instrutor }}</td>
                                <td>{{ aula.data_aula }}</td>
                                <td>{{ aula.status_registro }}</td>
                                <td v-if="aula.data_registro !== 'Hoje'">{{ `${aula.data_registro} Dias` }}</td>
                                <td v-else>{{ aula.data_registro }}</td>
                            </tr>
                        </tbody>
                    </table>
                </template>
                <template v-else>
                    <component class="my-3" :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'"
                        :size="80">
                    </component>
                </template>
            </template>
            <template v-else>
                <component class="my-3" :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80">
                </component>
            </template>
            <div class="row">
                <div class="col mx-auto">
                    <pagination :source="pagination" @navigate="navigate" class="pagination justify-content-center">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as spinners from 'epic-spinners'
import RelatoriosController from '../RelatoriosController'
import PraticasRelatorio from './PraticasRelatorio'
import pagination from '../../../pagination/pagination'
import urlApi from '@/router/urlApiV2'
import { ModelSelect } from 'vue-search-select'

export default {
  name: 'PraticasPendentes',
  components: {
    ...spinners,
    pagination,
    urlApi,
    ModelSelect,
  },
  props: {
    selectCFC: Array,
  },
  data () {
    return {
      table: {
        current_page: '',
        data: '',
        first_page_url: '',
        from: '',
        last_page: '',
        last_page_url: '',
        next_page_url: '',
        path: '',
        per_page: '',
        prev_page_url: '',
        to: '',
        total: '',
        pages: [],
        load: false,
        tp: '',
      },
      pagination: '',
      download: {
        load: false
      },
      dataInicial: '',
      dataFinal: '',
      aulas: [],
      aulasLoading: false,
      consult: '',
      selectedCFC: '',
      filtros: {
        selectedCFC: '',
        dataInicio: '',
        dataFim: '',
        nomeAluno: '',
        instrutor: '',
      },
    }
  },
  methods: {
    getPraticasPendentes () {
      this.download.load = true
      var data = {
        dataInicial: this.dataInicial,
        dataFinal: this.dataFinal
      }
      if (this.dataInicial === '' || this.dataFinal === '') {
        this.launchToast('fa-warning', 'Por favor, informe o período!')
        this.download.load = false
      } else {
        RelatoriosController.getPraticasPendentes(data, (response) => {
          if (response.sucesso === false) {
            this.download.load = false
          } else {
            var csv = 'data:text/csv;charset=utf-8,' + response.dados
            var dlnk = document.getElementById('downloadCSV')
            dlnk.download = 'praticas-pendentes.csv'
            dlnk.href = csv
            dlnk.click()
            this.download.load = false
          }
        })
      }
    },
    searchBy () {
      console.log(this.filtros.selectedCFC)
      if (this.filtros.selectedCFC === '') {
        this.launchToast('fa-warning', 'Por favor, selecione uma autoescola!')
      } else {
        const data = {
          schema: this.filtros.selectedCFC,
          aluno: this.filtros.nomeAluno,
          instrutor: this.filtros.instrutor,
          dataInicio: this.filtros.dataInicio,
          dataFim: this.filtros.dataFim,
        }

        this.getAulas(data)
      }
    },
    getAulas (data) {
      this.consult = `${urlApi}/aulas/praticas/relatorio/pendentes-rejeitadas?schema=${data.schema}&aluno=${data.aluno}&instrutor=${data.instrutor}&periodoI=${data.dataInicio}&periodoF=${data.dataFim}`

      this.aulasLoading = true

      PraticasRelatorio.getAulas(data, (response) => {
        if (response.sucesso === false) {
          this.aulasLoading = false
        } else {
          this.aulasLoading = false

          this.callbackDataPaginate(response.dados)

          this.aulas = response.dados.data
        }
      })
    },
    clearInputs () {
      this.aulas = []
      this.table.current_page = ''
      this.table.data = ''
      this.table.first_page_url = ''
      this.table.from = ''
      this.table.last_page = ''
      this.table.last_page_url = ''
      this.table.next_page_url = ''
      this.table.path = ''
      this.table.per_page = ''
      this.table.prev_page_url = ''
      this.table.to = ''
      this.table.total = ''
      this.table.pages = []
      this.table.load = false
      this.table.tp = ''
      this.pagination = ''
      this.filtros.nomeAluno = ''
      this.filtros.instrutor = ''
      this.filtros.selectedCFC = ''
      this.filtros.dataInicio = ''
      this.filtros.dataFim = ''
    },
    callbackDataPaginate (response) {
      let res = response
      this.table.current_page = res.current_page
      this.aulas = res.data
      this.table.first_page_url = res.first_page_url
      this.table.from = res.from
      this.table.last_page = res.last_page
      this.table.last_page_url = res.last_page_url
      this.table.next_page_url = res.next_page_url
      this.table.path = res.path
      this.table.per_page = res.per_page
      this.table.prev_page_url = res.prev_page_url
      this.table.to = res.to
      this.table.total = res.total
      this.table.pages = []

      for (let i = 1; i <= res.last_page; i++) {
        this.table.pages.push(i)
      }

      this.table.load = false
      this.pagination = res
      this.tp = res.data.length
    },
    async navigate (page) {
      this.table.load = true
      this.loadTable = true

      await this.$http.get(`${this.consult}&page=${page}`).then(function (response) {
        this.callbackDataPaginate(response.body.dados)

        this.loadTable = false
      })
      this.table.load = false
    },
    launchToast (icon, msg) {
      this.$toasted.show(msg, {
        position: 'top-right',
        icon: icon
      })
    }
  }
}
</script>
